import { createTheme } from '@mui/material/styles';

import aampeTheme from './constants/aampeTheme';

const theme = (createTheme as any)({
    defaults: {
        borderRadius: '4px',
        colorLight: aampeTheme.colors.solidA01,
        colorDark: '#1E282D',
        colorGray: '#7D7DAA',
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: aampeTheme.size.font.textMedium,
                color: aampeTheme.colors.white,
                backgroundColor: aampeTheme.colors.gray700,
            },
            arrow: {
                color: aampeTheme.colors.gray700,
            },
        },
    },
    typography: {
        fontFamily: 'Inclusive Sans Variable, Arial, sans-serif',
        button: {
            textTransform: 'none',
            fontWeight: 400,
            fontSize: '18px',
        },
        h1: {
            fontFamily: 'Inclusive Sans Variable',
            fontSize: '40px',
            color: '#272727',
            fontWeight: 700,
        },
        h2: {
            fontFamily: 'Inclusive Sans Variable',
            fontSize: '25px',
            color: '#000000',
            fontWeight: 600,
        },
        h4: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 600,
            fontSize: '20px',
            color: '#201E1E',
            userSelect: 'none',
            // textTransform: 'capitalize',
            margin: '10px 0 5px 0',
        },
        h5: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 500,
            fontSize: '18px',
        },
        h6: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 500,
            fontSize: '15px',
        },
        subtitle1: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 400,
            fontSize: '18px',
            color: '#201E1E',
            lineHeight: '25px',
        },
        body1: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 400,
            fontSize: '15px',
            color: '#3A3A3A',
        },
        body2: {
            fontFamily: 'Inclusive Sans Variable',
            fontWeight: 400,
            fontSize: '22px',
            color: '#3A3A3A',
        },
    },
    section: {
        maxWidth: '1400px',
        backgroundColor: '#fff',
        width: '100%',
        borderRadius: '5px',
        padding: '20px 20px 30px 20px',
        margin: '0 0 20px 0',
    },
    input: {
        padding: '10px',
        height: '40px',
    },
    palette: {
        primary: {
            main: '#00264f',
            light: '#374e7b',
            dark: '#001a37',
            text: '#fff',
        },
        secondary: {
            main: aampeTheme.colors.solidA01,
            light: aampeTheme.colors.solidA01,
            highlight: aampeTheme.colors.primary50,
            text: '#FFFFFF',
        },
        background: {
            main: aampeTheme.colors.primary50,
            light: '#FFFFFF',
            text: '272727',
        },
        input: {
            main: 'rgba(164, 174, 194, 0.2)',
            text: '#7D7DAA',
        },
        textInput: {
            main: '#CACAD1',
            light: '#FFF',
            text: '#1E282D',
        },
        boost: {
            true: '#6DDE16',
            false: '#E5E9F0',
        },
        sideNav: {
            main: '#FFFFFF',
            text: '#B5B5D2',
        },
        sideNavSubItems: {
            text: '#969696',
            activeText: '#272727',
        },
        surface: {
            main: 'rgb(238, 238, 238)',
            text: '#eeeeee',
        },
        link: {
            main: '#3E9EF8',
        },
        error: {
            main: '#FF6C6C',
            light: '#FFF3F3',
        },
        disabled: {
            main: 'rgba(0, 0, 0, 0.23)',
            text: '',
        },
        success: {
            main: '#4BB543',
            text: '#fff',
        },
        ValueProposition: {
            primary: '#6A6AB7',
            text: '#fff',
        },
        Offering: {
            primary: '#D457E8',
            text: '#fff',
        },
        Other: {
            primary: '#7D7DAA',
            text: '#fff',
        },
        CallToAction: {
            primary: '#2DC08B',
            text: '#fff',
        },
        Incentive: {
            primary: aampeTheme.colors.solidA01,
            text: '#fff',
        },
        Greeting: {
            primary: '#45B6EF',
            text: '#fff',
        },
        NoVariant: {
            primary: '#9696BE',
            text: '#fff',
        },
        buttons: {
            primary: {
                bg: aampeTheme.colors.solidA01,
                text: '#fff',
                border: aampeTheme.colors.solidA01,
                onClickBg: aampeTheme.colors.solidA01,
                onClickText: '#FFF',
                onClickBorder: aampeTheme.colors.solidA01,
                disabledBg: 'gray',
                disabledText: 'lightgray',
            },
            secondary: {
                bg: '#FF7D451A',
                text: aampeTheme.colors.solidA01,
                border: aampeTheme.colors.solidA01,
                onClickBg: aampeTheme.colors.solidA01,
                onClickText: aampeTheme.colors.solidA01,
                onClickBorder: aampeTheme.colors.solidA01,
                disabledBg: 'gray',
                disabledText: 'lightgray',
            },
            red: {
                backgroundColor: '#FFF3F3',
                color: '#FF2929',
                border: '#FF2929',
            },
            orange: {
                backgroundColor: '#FFF4EF',
                color: '#FF5F48',
                border: '#FF5F48',
            },
            green: {
                backgroundColor: '#EBFFFF',
                color: '#05ADA9',
                border: '#05ADA9',
            },
            white: {
                backgroundColor: '#FFFFFF',
                color: '#9696BE',
            },
        },
        status: {
            active: {
                backgroundColor: '#EBFFFF',
                color: '#05ADA9',
            },
            revoked: {
                backgroundColor: aampeTheme.colors.backgroundWG02,
                color: '#3A3A3A',
            },
            incomplete: { backgroundColor: '#FFF4EF', color: '#FF5F48' },
        },
        widgets: {
            orange: '#FFF4F6',
            blue: '#F9FAFF',
            green: '#EAFFF7',
            red: '#FFF6FC',
        },
    },
});

export default theme;
